module.exports = __webpack_public_path__ + "static/media/MA.9093d828.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MA.svg
// module id = 2202
// module chunks = 7